import * as React from "react";

function SvgShareSquare({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="currentColor"
          d="M12 2.25a.75.75 0 01.102 1.493L12 3.75H8a4.25 4.25 0 00-4.245 4.044L3.75 8v8a4.25 4.25 0 004.044 4.245L8 20.25h8a4.25 4.25 0 004.245-4.044L20.25 16v-4a.75.75 0 011.493-.102l.007.102v4a5.75 5.75 0 01-5.53 5.746l-.22.004H8a5.75 5.75 0 01-5.746-5.53L2.25 16V8a5.75 5.75 0 015.53-5.746L8 2.25h4zm5.452 1.147l.084.073 2.995 2.997a.74.74 0 01.156.229l.017.045.016.044a.76.76 0 01.021.33l-.003.015a.744.744 0 01-.23.422L17.53 10.53a.75.75 0 01-1.134-.976l.072-.084 1.716-1.72H15a3.25 3.25 0 00-3.245 3.066L11.75 11v.5a.75.75 0 01-1.493.102l-.007-.102V11a4.75 4.75 0 014.533-4.745L15 6.25h3.194l-1.719-1.72a.75.75 0 01-.072-.977l.073-.084a.75.75 0 01.976-.072z"
        />
      </g>
    </svg>
  );
}

export default SvgShareSquare;
